import { Trans, useTranslation } from 'react-i18next';
import React from 'react';

import { OnboardingStyle } from '../../../public/onboarding/onboarding-style';
import { AuthHeader } from '../../../../global-styles/layout';
import { Heading2Text } from '../../../../components/typography/typography';
import { images } from '../../../../assets/images/images';
import { ISuccessUbicationProps } from './success-ubication-types';
import { SuccessUbicationStyle } from './success-ubication-style';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SuccessUbication: React.FC<ISuccessUbicationProps> = ({ identifier, file, nextStep }) => {
  const { t } = useTranslation(['common', 'auth', 'ubication']);
  return (
    <>
      <SuccessUbicationStyle>
        <OnboardingStyle>
          <div className="onboarding-top">
            <AuthHeader>
              <div className="auth-header-title">
                <Heading2Text as="h1" weight={600}>
                  <Trans t={t} i18nKey="ubication:success.title">
                    Ubicación enviada con éxito.
                  </Trans>
                </Heading2Text>
              </div>
            </AuthHeader>

            <div className="container-image">
              <img src={images.cars2} alt="" />
            </div>
          </div>
        </OnboardingStyle>
      </SuccessUbicationStyle>
    </>
  );
};

export default SuccessUbication;
